import { useParams } from 'react-router-dom'

export const useAdjustmentIdParam = (): string => {
  const params: any = useParams()
  return params?._id ?? undefined
}
